// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"118":"26d335da","668":"5b6a482e","806":"6019df47"}[chunkId] + ".js";
};